import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Mailbox } from '../../models/mailboxes.model';

@Component({
  selector: 'mprd-mailboxes-list',
  templateUrl: 'mailboxes-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailboxesListComponent implements OnInit {
  @Input() mailboxes: Mailbox[];
  @Input() selectedMailbox: Mailbox;
  @Output() selectMailbox: EventEmitter<Mailbox> = new EventEmitter();

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.selectedMailbox = this.mailboxes[0];
  }

  changeSelectedMailbox(mbxId: string) {
    const newSelectedMailbox = this.mailboxes.find(
      (mailbox) => mailbox.mbxId === mbxId,
    );
    this.selectMailbox.emit(newSelectedMailbox);
  }
}
